import React from "react";
import { LegacyRef } from "react";

interface IRef {
  inputRef?: LegacyRef<HTMLInputElement>;
}

const InputEx = (
  props: React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > &
    IRef
) => {
  return (
    <div className="focusWrap">
      <input autoComplete="new-password" ref={props.inputRef} {...props} />
      <span className="focus-input100" />
    </div>
  );
};

export { InputEx };
